var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{style:('background: url(' + (_vm.theme === 'light' ? _vm.homeBgLight : _vm.homeBgDark) + ') center center / cover;opacity: 1;height: 100%;'),attrs:{"fluid":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }